<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-sort
    v-model="selectedItemIds"
    data-url="admin/sor/"
    data-key="sors"
    :extra-filters="{
      type: [SOR_TYPE.A_SOR],
      'contract.id': [contractId],
    }"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="sor-list"
  >
    <template #item.type="{ value }">
      {{ $t(`sor_type.${value}`) }}
    </template>
    <template #item.finalised_at="{ value }">
      {{ value ? $parseDate(value) : "" }}
    </template>
    <template #item.action_input_finalised_at="{ value }">
      {{ value ? $parseDate(value) : "" }}
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn text color="primary" @click="onItemClick(item)"> More </v-btn>
        <v-btn
          text
          color="primary"
          v-if="canDeleteItem(item)"
          @click="deleteItem(item)"
        >
          Delete
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { PERMISSIONS, SOR_TYPE, USER_TYPE } from "@/constants";

export default {
  name: "ContractASorList",
  components: { RemotePaginatedList },
  props: {
    contractId: String,
    value: Array,
    refreshTrigger: Boolean,
    contract: Object,
  },
  setup(props, { root, emit }) {
    const me = computed(() => root.$me());
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("sor.type"), value: "type", width: 100 },
      { text: root.$t("sor.name"), value: "name", sortable: false },
      { text: root.$t("sor.finalised_at"), value: "finalised_at", width: 150 },
      {
        text: root.$t("sor.action_input_finalised_at"),
        value: "action_input_finalised_at",
        width: 150,
      },
      { text: "", value: "actions", sortable: false, width: 200 },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({ name: "sor-detail", params: { sorId: item.id } });
    };
    const exportPdf = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/section/export_pdf/",
        params: {
          section_id: item.id,
        },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `${item.name}.pdf`;
      link.click();
    };

    const canDeleteItem = function (item) {
      return (
        ([USER_TYPE.ADMIN, USER_TYPE.SUPER_ADMIN].indexOf(me.value.type) !==
          -1 ||
          me.value.managed_contract_ids.indexOf(props.contractId) !== -1) &&
        !item.action_input_finalised_at
      );
    };
    const deleteItem = async function (item) {
      if (await root.$dialog.confirm({ text: "Delete A-SoR?" })) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/contract/a_sor/delete/",
          params: { a_sor_id: item.id },
        });

        if (response.body.success) {
          await refresh();
        }
      }
    };

    const onItemClick = function (item) {
      root.$router.push({ name: "a-sor-detail", params: { aSorId: item.id } });
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      exportPdf,
      canDeleteItem,
      deleteItem,

      onItemClick,

      SOR_TYPE,
      PERMISSIONS,
    };
  },
};
</script>

<style lang="less">
.sor-list {
}
</style>
